import {maybe} from '@freckle/maybe'
import {saferStringify} from '@freckle/parser'
import {ActionableError} from './base/actionable-error'
import {NonActionableError} from './base/non-actionable-error'

export class ActionableHttpError extends ActionableError {
  constructor(
    public url: string,
    public method: string,
    public status: number,
    public response: {response: Response; text?: string; json?: unknown},
    public cause?: unknown
  ) {
    super(`${method} ${url} responded with ${status} - ${getResponseMessage(response)}`)
    this.name = 'ActionableHttpError'
  }
}

export class NonActionableHttpError extends NonActionableError {
  constructor(
    public url: string,
    public method: string,
    public status: number,
    public response: {response: Response; text?: string; json?: unknown},
    public cause?: unknown
  ) {
    super(`${method} ${url} responded with ${status} - ${getResponseMessage(response)}`)
    this.name = 'NonActionableHttpError'
  }

  hasValidationError(name: string): boolean {
    return this.getErrorNames()?.includes(name) ?? false
  }
  getErrorNames(): string[] | null {
    return (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.response.json as any)?.validationErrors?.map(({name}: {name: string}) => name) ?? []
    )
  }
}

const getResponseMessage = (response: {response: Response; text?: string; json?: unknown}) => {
  return maybe(
    () => response.text,
    json => saferStringify(json),
    response.json
  )
}
